<template>
	<div style="min-height: 40px" >
		<div>
			<el-card class="box-card" shadow="never"  v-loading="loading" style="min-height: 100px">
				<div class="body-box" style="height: 300px" v-if="chartOption">
					<chart-sub :option="chartOption" :chartType="'stockChart'" :data_height="300"></chart-sub>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import { COUNTRY_CODE_MAP } from "@/components/config/countryCodeConfig";
import Chart from "@/components/template/otherSub/hightChartSub";
import {
	api_getKeywordsNumTrendByTerm
} from "@/components/api/keywordReverseSearch";
import { formatAsinReverseSearchTrends } from "@/components/config/chart/asinReverseLookup";

export default {
	name: "termTrends",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading : false,
			chartOption : null,
			search : {
				term : null,
				country : 'US',
				startTime : '2021-05-02',
				endTime : null
			}
		};
	},
	props : {
		term : {},
		startTime : {},
		endTime : {},
		country : {
			default : COUNTRY_CODE_MAP[0].value
		}
	},
	components : {
		'chart-sub': Chart,
	},
	created() {
		this.$data.search.term = this.term
		this.$data.search.country = this.country
		if (this.startTime){
			this.$data.search.startTime = this.startTime
		}
		if (this.endTime){
			this.$data.search.endTime = this.endTime
		}
		this.$options.methods.loadTrend(this)
	},
	methods: {
		loadTrend : function(this_) {
			this_ = this_ || this
			let search = { ...this_.$data.search }
			this_.$data.loading = true
			api_getKeywordsNumTrendByTerm(search).then(res => {
				let data = res.data
				let option = formatAsinReverseSearchTrends(data.results)
				// 绑定事件
				option.plotOptions.series.events.click = (e) => {
					// this_.$data.infoSearch.date =
					this_.$emit('clickColumn',this_.$fomatTime(e.point.x))
				}
				this_.$data.chartOption = option
				this_.$data.loading = false
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请重新尝试'), 4)
			})
		}
	}, watch: {
		term : {
			handler() {
				this.$options.methods.loadTrend(this)
			},
			deep: true
		},
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>

</style>